export default {"src":"/_next/static/media/stopwatch.4a134a7c.svg","height":20,"width":20};